import React from "react"
import { Stack, Container, Skeleton } from "@mui/material"
import CardCarousel from "@/components/base/CardCarousel"

const AdsSkeletonItem = ({ isHome }: { isHome?: boolean }) => {
  return (
    <Stack
      direction={{ xs: "column", sm: isHome ? "column" : "row" }}
      className='bg-white border border-solid border-secondary rounded-lg p-5 h-full'
      gap={2}
    >
      <Skeleton
        className={`rounded-lg hidden sm:block ${isHome ? "w-full h-[209px]" : "w-[179px] h-[99px]"}`}
        variant='rectangular'
      />

      <Stack gap={0} className='flex-1'>
        <Skeleton variant='text' className='w-full' height={25} />
        <Skeleton variant='text' className='w-full' height={44} />
        <Skeleton variant='text' width={100} height={25} />
      </Stack>
    </Stack>
  )
}

const AdsSkeleton = ({ isHome }: { isHome?: boolean }) => {
  return (
    <Container data-test-id='adSection' maxWidth='xl' className={isHome ? "mt-10 px-0" : "mt-4"}>
      <CardCarousel
        id='advertisement'
        xs={1}
        sm={1}
        md={isHome ? 3 : 2}
        autoplay={{ delay: 3000 }}
        items={Array.from({ length: isHome ? 3 : 2 }).map((_, i) => (
          <AdsSkeletonItem key={i} isHome={isHome} />
        ))}
      />
    </Container>
  )
}

export default AdsSkeleton
